import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./UploadFile.module.css";
import { useDropzone } from "react-dropzone";
import {
  baseStyle,
  activeStyle,
  acceptStyle,
  rejectStyle,
} from "../../utilities/styleUtilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport, faHandPointUp } from "@fortawesome/free-solid-svg-icons";

function UploadFile({ getFiles, size }) {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: "image/*, video/*, .pdf, .docx, .doc, .xlsx, .xls, .csv",
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      getFiles(acceptedFiles);
    }
  }, [acceptedFiles]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={styles.container}>
      <div className={styles.infoContainer}>
        <span>Accepts images, videos, PDF, Word, and Excel files</span>
        <span>
          <strong>
            {useSelector((state) => state.app.config.totalFileLimit)}
          </strong>{" "}
          File Maximum
        </span>
        <span>
          <strong style={size > 25 ? { color: "red" } : {}}>{size}</strong>/
          {useSelector((state) => state.app.config.totalFileSizeLimitPretty)}
        </span>
      </div>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} id="uploadFile" />
        <label style={{ textAlign: "center" }} htmlFor="uploadFile">
          Are there any related claim documents to upload?
        </label>
        <div className={styles.iconContainer}>
          <span
            className={`${styles.iconText} ${styles.uploadText} ${styles.doNotShowOnMobile}`}
          >
            DRAG/DROP
          </span>
          <FontAwesomeIcon
            className={`${styles.doNotShowOnMobile} ${styles.fileIcon}`}
            icon={faFileImport}
            size="2x"
          />
          <span className={`${styles.doNotShowOnMobile} ${styles.iconText}`}>
            OR
          </span>
          <FontAwesomeIcon
            className={styles.fileIcon}
            icon={faHandPointUp}
            size="2x"
          />
          <button
            className={`${styles.iconText} ${styles.uploadText}`}
            onClick={(event) => event.preventDefault()}
          >
            CLICK HERE
          </button>
        </div>
      </div>
    </div>
  );
}

export default UploadFile;
